import React from 'react'
import styles from './MessageCard.sass'

interface CardProps {
  children?: React.ReactNode
}

/**
 * Card
 */
export function Card({ children }: CardProps) {
  return <div className={styles.card}>{children}</div>
}

interface CardContentProps {
  visual?: React.ReactNode
  title?: React.ReactNode
  children?: React.ReactNode
}

/**
 * Card Content
 */
export function CardContent({ visual, title, children }: CardContentProps) {
  return (
    <div className={styles.cardContent}>
      {visual && <div className={styles.cardContentVisual}>{visual}</div>}
      <div className={styles.cardContentCopy}>
        {title && <h3 className={styles.cardContentTitle}>{title}</h3>}
        <p className={styles.cardContentBody}>{children}</p>
      </div>
    </div>
  )
}

interface CardFooterProps {
  children?: React.ReactNode
}

/**
 * Card Footer
 */
export function CardFooter({ children }: CardFooterProps) {
  return <div className={styles.cardFooter}>{children}</div>
}

interface CardFooterItemProps {
  children?: React.ReactNode
}

/**
 * Card Footer Item
 */
export function CardFooterItem({ children }: CardFooterItemProps) {
  return <div className={styles.cardFooterItem}>{children}</div>
}

interface CardFooterSpacerProps {
  children?: React.ReactNode
}

/**
 * Card Footer Spacer
 */
export function CardFooterSpacer({ children }: CardFooterSpacerProps) {
  return <div className={styles.cardFooterSpacer}>{children}</div>
}

interface CardFooterCopyProps {
  title?: React.ReactNode
  children?: React.ReactNode
}

/**
 * Card Footer Copy
 */
export function CardFooterCopy({ title, children }: CardFooterCopyProps) {
  return (
    <div className={styles.cardFooterCopy}>
      {title && <h6 className={styles.cardFooterCopyTitle}>{title}</h6>}
      <div className={styles.cardFooterCopyBody}>{children}</div>
    </div>
  )
}
